import Dashboard from './pages/Dashboard';
import Companies from './pages/Companies';
import Accounts from './pages/Accounts';
import Transactions from './pages/Transactions';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Inventory from './pages/Inventory';
import Warehouses from './pages/Warehouses';
import SalesInvoices from './pages/SalesInvoices';
import PurchaseInvoices from './pages/PurchaseInvoices';
import Ledger from './pages/Ledger';
import __Layout from './Layout.jsx';


export const PAGES = {
    "Dashboard": Dashboard,
    "Companies": Companies,
    "Accounts": Accounts,
    "Transactions": Transactions,
    "Reports": Reports,
    "Settings": Settings,
    "Inventory": Inventory,
    "Warehouses": Warehouses,
    "SalesInvoices": SalesInvoices,
    "PurchaseInvoices": PurchaseInvoices,
    "Ledger": Ledger,
}

export const pagesConfig = {
    mainPage: "Dashboard",
    Pages: PAGES,
    Layout: __Layout,
};